
export default class Locations {
	constructor(el) {
		this.el = el;
		this.items = [...this.el.querySelectorAll('.location:not(.location--empty)')];
		this.closeBtn = this.el.querySelector('.locations__overlay__close');
		this.overlay = this.el.querySelector('.locations__overlay');
		this.modals = [...this.el.querySelectorAll('.location-modal')];

		this.prevBtn = this.el.querySelector('.locations__nav--prev');
		this.nextBtn = this.el.querySelector('.locations__nav--next');

		this.html = document.querySelector('html');

		this.modalIsOpen = false;
		this.currentModal = -1;

		this.init();
		this.events();
	}

	init() {
		this.total = this.items.length;
	}

	events() {
		this.items.forEach((item, i) => {
			item.addEventListener('click', this.openModal.bind(this, item, i));
		});

		this.closeBtn.addEventListener('click', this.close.bind(this));

		this.prevBtn.addEventListener('click', this.prev.bind(this));
		this.nextBtn.addEventListener('click', this.next.bind(this));
	}


	openModal(item, i) {
		const id = item.getAttribute('data-location-id');
		const modal = this.el.querySelector(`.location-modal[data-location-id="${id}"]`);

    if (document.querySelector('body').classList.contains('report--2018') && window.innerWidth >= 1025) {
      // do nothing
    } else {
  		if (modal) {
  			this.html.classList.add('modal-open');
  			this.overlay.classList.add('active');
  			modal.classList.add('active');
  			this.modalIsOpen = true;
  			this.currentModal = i;
  			this.arrowHandle();
  		}
		}
	}

	arrowHandle() {
		if (this.currentModal > 0) {
			this.prevBtn.classList.add('active');
		} else {
			this.prevBtn.classList.remove('active');
		}

		if (this.currentModal > -1 && this.currentModal < this.total - 1) {
			this.nextBtn.classList.add('active');
		} else {
			this.nextBtn.classList.remove('active');
		}
	}

	close() {
		this.html.classList.remove('modal-open');
		this.overlay.classList.remove('active');
		this.modalIsOpen = false;
		this.closeAllModals();
	}

	closeAllModals() {
		this.modals.forEach(modal => {
			modal.classList.remove('active');
		});
	}

	prev() {
		if (this.currentModal > 0) {
			this.closeAllModals();
			const newIndex = this.currentModal - 1;
			this.openModal(this.items[newIndex], newIndex);
		}
	}

	next() {
		if (this.currentModal > -1 && this.currentModal < this.total - 1) {
			this.closeAllModals();
			const newIndex = this.currentModal + 1;
			this.openModal(this.items[newIndex], newIndex);
		}
	}
}
